import React, {useState, useEffect, useRef} from 'react';

import ExtendedButton from '@src/stories/elements/ExtendedButton/ExtendedButton';
import { fetchCart } from 'frontend/js/useShopifyCart';
import CartTitle from './components/CartTitle';
import CartItems from './components/CartItems';
import shippingitem from "frontend/js/alpine/components/cart/shippingitem";
import { updateItems } from 'frontend/js/useShopifyCart';
import { useCart } from 'frontend/js/useShopifyCart';
import { ProductType } from '../ExtendedCart/components/CartEnums';
import clsx from "clsx";
import DOMPurify from 'dompurify';
import { Paragraph } from "@mindarc/arctheme-components/frontend/src/stories/components/elements/Paragraph/Paragraph";

export const addIconsToListItems = (html, usp_bullet_icon) => {
  const div = document.createElement('div');
  div.innerHTML = DOMPurify.sanitize(html);
  
  const listItems = div.querySelectorAll('li');
  listItems.forEach(li => {
    const iconSpan = document.createElement('span');
    iconSpan.className = `icon-${usp_bullet_icon}`;
    iconSpan.style.marginRight = '8px';
    li.prepend(iconSpan);
  });

  
  const strongElements = div.querySelectorAll('strong');
  strongElements.forEach(strong => {
    strong.classList.add('b4--bold');
  });
  
  
  return div.innerHTML;
};


export default function ExtendedMinicart ({ style = 'drawer', settings, shipping_id,  gift_wrap_types, card_types, usp_content, usp_bullet_icon, bulk_rate_threshold }) {
  const { cart, hampers } = useCart(true);
  const [updatingCart, setUpdatingCart] = useState(false);
  const excludedIds = [
    // ...card_types.map(item => item.id),
    // ...gift_wrap_types.map(item => item.id),
    Number(shipping_id)
  ];
  const submitCheckoutBtn = useRef(null); 

  const hamperCount = cart && cart.items.reduce((count, item) => {
    if (item.product_type === ProductType.HAMPER && hampers[item.variant_id] && hampers[item.variant_id].length > 0) {
      return count + item.quantity;
    }
    return count;
  }, 0);
  
  const filteredCartItems = cart && cart.items.filter(
    (cartItem) => !excludedIds.includes(cartItem.variant_id)
  );

  const shippingItems = cart && cart.items.filter((item) => item.id === Number(shipping_id));
  const totalShippingPrice = shippingItems && shippingItems.reduce((acc, item) => acc + item.price, 0);

  // Update and delete shipping cost items on initial cart journey load if minicart only has gift cards
  const removeShippingItems = shippingItems.reduce((acc, item) => {
    acc[item.key] = 0;
    return acc;
  }, {});

  const isGiftCardOnlyCart =  filteredCartItems && filteredCartItems.every(
    item => item.product_type === "Gift Cards"
  );

  async function handleValidation () {
    if (isGiftCardOnlyCart) {
      setUpdatingCart(true);
      try {
        // Direct fetch call to update cart
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ updates: removeShippingItems }),
        });
        
        if (response.ok) {
          setTimeout(() => {
            submitCheckoutBtn.current.submit();
       
          }, 500);
        } else {
          console.error('Failed to update cart');
        }
      } catch (error) {
        console.error('Error updating cart:', error);
      } finally {
        setUpdatingCart(false);
      }
    }
    else {
      window.location.href = '/cart';
    }
  } 

  return (
    <>
      <div
        className='extended-minicart__overlay'
        x-cloak="true"
        x-show="$store.global.isMinicartVisible"
      />

      <div className={`extended-minicart__wrapper ${style}`}
        x-cloak="true"
        x-transition:enter="transition ease-out duration-300"
        x-transition:enter-start="off-screen-right"
        x-transition:enter-end="right-50"
        x-transition:leave="transition ease-in duration-300"
        x-transition:leave-start="right-50"
        x-transition:leave-end="off-screen-right"
        x-show="$store.global.isMinicartVisible"
      >
        <div className={'extended-minicart overflow-auto'}>
          <CartTitle item_count={filteredCartItems && filteredCartItems.length} />

          <CartItems
            cartItems={filteredCartItems}
            hampers={hampers}
            show_total_price={settings.show_total_price}
          />

          {cart.items.length === 0
            ? <div className={'flex flex-col gap-y-[16px] text-center h-full justify-center p-[16px]'}>
                <div className={'b2'}>
                  {settings.empty_text_one}

                  <br/>

                  {settings.empty_text_two}
                </div>

                <a
                  x-on:click="$store.global.toggleMinicart()"
                  className={'minicart-empty__button button button-primary'}
                >
                  {settings.empty_button}
                </a>
              </div>

            : <div className='extended-minicart__footer'>
                { hamperCount >= bulk_rate_threshold && 
                    <div className={clsx('extended-minicart__usp-content text-center border rounded-lg p-3 my-4', {
                                'custom-icon': usp_bullet_icon !== '',
                              })}>
                          <Paragraph
                            text={usp_content ? addIconsToListItems(usp_content, usp_bullet_icon) : ''}
                            type={'rich-content'}

                      />
                    </div>
                }
                <div className="extended-minicart__total">
                  <h5 className='h5'>
                    Total
                  </h5>

                  <h5 className='h5'>
                    {`$${((cart.total_price - totalShippingPrice) / 100).toFixed(2)}`}
                  </h5>
                </div>

   

                <div className='extended-minicart__checkout-button'>
                  <ExtendedButton
                    style="primary"
                    label={ updatingCart ? "Updating Cart..." : "Checkout" }
                    disabled={updatingCart}
                    onClick={() => handleValidation()}
                  />

                <form id="checkout" action="/checkout" method="post" ref={submitCheckoutBtn}></form>
                </div>
              </div>
          }
        </div>
      </div>
    </>
  );
}
